module.exports = __webpack_public_path__ + "img/Frame783.057b6276.png";